export default "__VITE_ASSET__CgjotPM4__"